
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from "vue";

import FsLightbox from "fslightbox-vue/v3";
import {
  printClose,
  printConnect,
  printStart2,
} from "@/core/directive/function/print";
import { PrinterConfigTaskDocumentContent } from "./core/directive/interface/print";
import store from "./store";
import { Actions, Mutations } from "./store/enums/StoreEnums";
import { isMobile } from "./core/directive/function/common";
import _ from "lodash";

export default defineComponent({
  name: "app",
  components: {
    FsLightbox,
  },
  setup() {
    const currentInstance: any = getCurrentInstance();

    const options = ref({
      toggler: false,
      sources: [] as any[],
      sourcesSlide: 1,
    });

    const previewImages = () => {
      currentInstance.proxy.emitter.on("preview-images", function (obj) {
        options.value.sources = obj.sources;
        options.value.toggler = true;
        setTimeout(() => {
          options.value.sourcesSlide = obj.sourcesSlide;
        }, 0);
      });
    };

    const imageOpen = () => {
      // options.value.toggler = true;
    };

    const imageClose = () => {
      options.value = {
        toggler: false,
        sources: [] as any[],
        sourcesSlide: 1,
      };
    };

    const allPrint = () => {
      currentInstance.proxy.emitter.on(
        "all-print",
        function (contents: PrinterConfigTaskDocumentContent[]) {
          printStart2(contents);
        }
      );
    };

    const offEmitter = () => {
      currentInstance.proxy.emitter.off();
    };

    const checkViewport = (e) => {
      if (e.matches) {
        //手机版
        store.commit(Mutations.SET_WINDOW_IS_MOBILE, true);
      } else {
        //桌面版
        store.commit(Mutations.SET_WINDOW_IS_MOBILE, false);
      }
    };

    onMounted(() => {
      store.dispatch(Actions.GET_OWNER_SWITCH);
      previewImages();
      // printConnect();
      allPrint();
      checkViewport(isMobile);
      isMobile.addListener(checkViewport);
      // iOS10以后版本不接受meta标签
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    });

    onUnmounted(() => {
      // printClose();
      offEmitter();
    });

    return {
      options,
      previewImages,
      imageOpen,
      imageClose,
    };
  },
});
